import { render, staticRenderFns } from "./SpInput.vue?vue&type=template&id=1929a451&scoped=true&"
import script from "./SpInput.vue?vue&type=script&lang=js&"
export * from "./SpInput.vue?vue&type=script&lang=js&"
import style0 from "./SpInput.vue?vue&type=style&index=0&id=1929a451&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929a451",
  null
  
)

export default component.exports